import type { PointStyles } from "~/types";

type InnerProps = Omit<PointStyles, "icon" | "size">;

export const IconMap = new Map([
  ["circle", Circle],
  ["square", Square],
  ["tearDrop", TearDrop],
  ["fatDrop", FatDrop],
]);

export default function BasicMarker({ icon, ...props }: PointStyles) {
  const Inner = IconMap.get(icon);
  if (!Inner) return null;

  return (
    <svg width={props.size} height={props.size} viewBox="0 0 100 100">
      <Inner {...props} strokeOpacity={1} />
    </svg>
  );
}

/**
 * Internal
 */

function Circle(props: InnerProps) {
  return (
    <circle
      cx="50"
      cy="50"
      r="42"
      fill={props.fillColor}
      stroke={props.strokeColor}
      strokeOpacity={props.strokeOpacity}
      strokeWidth={props.strokeWeight}
    />
  );
}

function Square(props: InnerProps) {
  return (
    <g transform="translate(10, 5)">
      <path
        d="M5 20C5 11.7157 11.7157 5 20 5H60C68.2843 5 75 11.7157 75 20V60C75 68.2843 68.2843 75 60 75H56.5L40 87.5L22.5 75H20C11.7157 75 5 68.2843 5 60V20Z"
        fill={props.fillColor}
        stroke={props.strokeColor}
        strokeOpacity={props.strokeOpacity}
        strokeWidth={props.strokeWeight}
      />
    </g>
  );
}

function TearDrop(props: InnerProps) {
  return (
    <path
      d="M53.1197 75.404C47.3167 82.8349 41.3891 89.0784 37.7112 92.7601C34.0333 89.0784 28.1057 82.8349 22.3026 75.404C18.0682 69.9816 13.9748 64.0213 10.8737 58.0411C7.74878 52.0149 5.78908 46.2675 5.4914 41.2064C4.18752 19.0378 21.8231 5.16989 37.7112 5.00153C53.5992 5.16989 71.2348 19.0378 69.931 41.2064C69.6333 46.2675 67.6736 52.0149 64.5487 58.0411C61.4476 64.0213 57.3541 69.9816 53.1197 75.404Z"
      fill={props.fillColor}
      stroke={props.strokeColor}
      strokeOpacity={props.strokeOpacity}
      strokeWidth={props.strokeWeight}
      transform="translate(12.5 0)"
    />
  );
}

function FatDrop(props: InnerProps) {
  return (
    <path
      d="M5 40C5 20.67 20.67 5 40 5C59.33 5 75 20.67 75 40C75 48.9375 72.4366 56.0436 66.2286 63.1754C62.7591 67.1614 55.2875 75.5153 48.6542 82.9047C45.3532 86.582 42.2694 90.0098 40.0066 92.5229C37.7726 90.0337 34.7349 86.6475 31.4723 83.0065C24.8848 75.655 17.3984 67.2847 13.7487 63.1496C8.30034 56.9766 5 48.8798 5 40Z"
      fill={props.fillColor}
      stroke={props.strokeColor}
      strokeOpacity={props.strokeOpacity}
      strokeWidth={props.strokeWeight}
      transform="translate(10 0)"
    />
  );
}
